import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "external--fill-current-color",
  "use": "external--fill-current-color-usage",
  "viewBox": "0 0 6 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 6\" id=\"external--fill-current-color\">\n    <path fill=\"currentColor\" d=\"M5.585 0h-4.15c-.229 0-.414.186-.414.415 0 .229.185.415.415.415h3.152L.12 5.297c-.161.16-.161.421 0 .582.16.161.422.161.582 0L5.17 1.412v3.152c0 .23.186.415.415.415.23 0 .415-.185.415-.415V.415C6 .192 5.808 0 5.585 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/external.svg?fill=currentColor
// module id = eU8d
// module chunks = 1